const register = {
  loginCredentials: "登录信息", // translated
  companyInformation: "公司信息", // translated
  contactDetails: "联系方式", // translated
  businessName: "公司名称", // translated
  businessAddress: "营业地址", // translated
  registrationCode: "注册码", // translated
  websiteUrl: "网址", // translated
  mobilePhone: "手机", // translated
  regionStateProvince: "地区/州/省", // translated
  legalTitle: "法定所有权", // translated
  city: "城市", // translated
  postalCode: "邮政编码", // translated
  registrationSuccess: "注册成功。", // translated
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome: "请稍等片刻，您将被重定向到主页。", // translated
};

export default register;
